import { isElectricVehicle } from 'site-modules/shared/utils/inventory-utils/engine';
import { isNew } from 'site-modules/shared/utils/inventory-utils/is-new';
import { isPartnerDealer } from 'site-modules/shared/utils/dealer-details-utils';

export const isEvModuleApplicable = vinData => {
  const { type } = vinData;
  const isEngineTypeElectric = isElectricVehicle(vinData);
  const isNewVehicle = isNew(type);
  const isPartnerListing = isPartnerDealer(vinData);
  const isNewPartner = isPartnerListing && isNewVehicle;

  return isEngineTypeElectric && (isNewPartner || !isNewVehicle);
};
